import React from 'react'
// import { Link } from 'react-router-dom'

//can have the data manually put throughout. Or map through an FAQ text document put in the data folder

const AssociatedPapers = () => {

  return (
    <div className="container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <h1 className="text-white" style={{ textAlign: 'center' }}>Coming Soon...</h1>
      <hr className="faqHR" />
      <div className="faqHeader">
        <h2>Papers associated with each pathway.</h2>
      </div>
      <hr className="faqHR" />
      {/* <div className="faqQuestion" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '700px' }}>
        <h3 style={{ marginBottom: '5px', marginTop: '5px' }}>Question Here</h3>
        <p style={{ marginTop: '0px' }}>Response Here</p>
        <hr className="faqHR" />
      </div> */}
    </div>
  )
}

export default AssociatedPapers